/** Copy appended after the formatted loyalty amount on unlock-with-points CTAs. */
export const UNLOCK_WITH_POINTS_BTN = {
  AMOUNT_POINTS_SUFFIX: ' Points'
} as const;
